export const validateEmail = (email:string) => {
    return String(email)
      .toLowerCase()
      .match(
        /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/g // Claude: allow long TLDs (.network, .technology etc) 22-02-2026
      );
  };

  export const disabledDate = (current:any) => {
    // Disable dates in the past
  // if (current && current < new Date()) {
  //   return true;
  // }

    // Disable dates before today
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set the time to the start of the day
    if (current && current < today) {
      return true;
    }

  // Disable dates more than 31 days in the future
  const nextMonth = new Date();
  nextMonth.setDate(nextMonth.getDate() + 31);
  if (current && current > nextMonth) {
    return true;
  }

  return false;
  };